export default {"src":"/_next/static/media/Program.82f62e77.svg","height":26,"width":26};